// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@PayPlans/views/Layers/Departments/Advisors";

const POSITION = "Service Advisor";

export default function Advisors() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"Service Advisors Pay Plans"} icon={Icon}>
			<Layer position={POSITION} defaultSections={["default"]} />
		</PageLayer>
	);
}
